import { FaBed, FaBath, FaRuler } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import usePublicProperties from "../hooks/usePublicProperties";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: false,
};

const renderMedia = (property, media, index) => {
  if (media.kind === "video") {
    return (
      <video
        src={media.url}
        muted
        playsInline
        controls
        className="property-media"
        aria-label={`${property.title} video ${index + 1}`}
      />
    );
  }

  return (
    <img
      src={media.url}
      alt={`${property.title} ${index + 1}`}
      loading={index === 0 ? "eager" : "lazy"}
      decoding="async"
      className="property-media"
    />
  );
};

const PropertyCard = ({ property }) => (
  <div className="property-card bg-white rounded-lg shadow-white shadow-lg overflow-hidden transition-transform duration-300 hover:scale-105">
    <div className="relative">
      <Slider {...settings} className="property-media-slider">
        {property.media.map((media, index) => (
          <div key={`${media.id}-${index}`}>
            <div className="property-media-frame">
              <Link to={`/properties/${property.slug}`} aria-label={`View ${property.title}`}>
                {renderMedia(property, media, index)}
              </Link>
            </div>
          </div>
        ))}
      </Slider>
    </div>
    <div className="property-card-body p-4">
      <Link to={`/properties/${property.slug}`} className="block">
        <h3 className="property-card-title text-xl font-semibold mb-2">{property.title}</h3>
      </Link>
      <p className="text-gray-600 mb-2">{property.location}</p>
      <p className="text-2xl font-bold text-primary mb-4">
        {new Intl.NumberFormat("en-NG", {
          style: "currency",
          currency: "NGN",
          maximumFractionDigits: 0,
        }).format(property.price)}
      </p>
      <div className="flex justify-between text-gray-600 mb-10">
        <span className="flex items-center">
          <FaBed className="mr-2" /> {property.beds} Beds
        </span>
        <span className="flex items-center">
          <FaBath className="mr-2" /> {property.baths} Baths
        </span>
        <span className="flex items-center">
          <FaRuler className="mr-2" /> {property.size} sqm
        </span>
      </div>
      <p className="property-card-desc text-gray-700 mb-4">{property.description}</p>
      <a
        href="https://wa.me/2348145765479"
        target="_blank"
        rel="noreferrer"
        className="property-card-cta block w-full bg-primary text-white py-2 px-4 rounded text-center hover:bg-secondary transition-colors duration-300"
      >
        Contact Agent
      </a>
    </div>
  </div>
);

const PropertyComponent = () => {
  const { properties, loading, error } = usePublicProperties({ limit: 30 });

  return (
    <div className="bg-gray-100 min-h-screen py-12">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-8">Our Properties</h1>

        {loading ? <p className="text-center text-gray-600">Loading properties...</p> : null}
        {error ? <p className="text-center text-red-600">{error}</p> : null}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {properties.map((property) => (
            <PropertyCard key={property.id} property={property} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PropertyComponent;
